import React, { Fragment, useEffect, useContext, useCallback, useState } from "react";
import Slider from "react-slick";
import { useHistory } from "react-router-dom";
import { getAllProduct } from "../../admin/products/FetchApi";
import { HomeContext } from "./index";
import { isWishReq, unWishReq, isWish } from "./Mixins";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck, faStar } from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const apiURL = process.env.REACT_APP_API_URL;

const SingleProduct = () => {
  const { data, dispatch } = useContext(HomeContext);
  const { products, loading } = data;
  const history = useHistory();
  const [wList, setWlist] = useState(JSON.parse(localStorage.getItem("wishList")));

  const fetchData = useCallback(async () => {
    dispatch({ type: "loading", payload: true });
    try {
      const responseData = await getAllProduct();
      if (responseData?.Products) {
        dispatch({ type: "setProducts", payload: responseData.Products });
      }
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
    } finally {
      dispatch({ type: "loading", payload: false });
    }
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    centerMode: true,
    swipeToSlide: true,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1, arrows: false, centerMode: true } },
    ],
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24 col-span-2 md:col-span-3 lg:col-span-4">
        <svg
          className="w-12 h-12 animate-spin text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
    );
  }

  return (
    <Fragment>
      <Slider {...settings} className="w-full px-2 md:px-4 lg:px-6">
        {products && products.length > 0 ? (
          products.map((item) => (
            <div key={item._id} className="p-2 group">
              <div className="relative overflow-hidden rounded-lg bg-gray-50">
                {item.pImages[1] && (
                  <img
                    onClick={() => history.push(`/products/${item._id}`)}
                    className="w-full h-64 object-cover object-center cursor-pointer transition-transform duration-300 ease-in-out transform group-hover:scale-105"
                    src={`${apiURL}/uploads/products/${item.pImages[1]}`}
                    alt={`${item.pName} segunda imagem`}
                  />
                )}

                {/* Wishlist buttons */}
                <div className="absolute top-2 right-2">
                  <button
                    onClick={(e) => isWishReq(e, item._id, setWlist)}
                    className={`${isWish(item._id, wList) ? "hidden" : "block"} p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors`}
                  >
                    <svg
                      className="w-5 h-5 text-gray-700 hover:text-red-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                      />
                    </svg>
                  </button>
                  <button
                    onClick={(e) => unWishReq(e, item._id, setWlist)}
                    className={`${!isWish(item._id, wList) ? "hidden" : "block"} p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors`}
                  >
                    <svg
                      className="w-5 h-5 text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Product Info */}
              <div className="mt-3 px-2">
                {/* Product Name */}
                <h3 
                  onClick={() => history.push(`/products/${item._id}`)}
                  className="text-lg font-semibold text-gray-900 hover:text-blue-600 cursor-pointer transition-colors line-clamp-2"
                  title={item.pName}
                >
                  {item.pName}
                </h3>

                {/* Ratings */}
                <div className="flex items-center mt-1">
                  <div className="flex items-center">
                    <FontAwesomeIcon icon={faStar} className="text-yellow-400 w-4 h-4" />
                    <span className="ml-1 text-sm text-gray-600">
                      {item.pRatingsReviews.length > 0 
                        ? (item.pRatingsReviews.reduce((acc, curr) => acc + curr.rating, 0) / item.pRatingsReviews.length).toFixed(1)
                        : "0.0"}
                    </span>
                  </div>
                  <span className="mx-1 text-gray-400">|</span>
                  <span className="text-sm text-gray-600">{item.pRatingsReviews.length} avaliações</span>
                </div>

                {/* Pricing */}
                <div className="mt-2">
                  {item.pOffer ? (
                    <>
                      <div className="flex items-baseline">
                        <span className="text-lg font-bold text-gray-900">R$ {item.pPrice.toFixed(2).replace('.', ',')}</span>
                        <span className="ml-2 text-xs line-through text-gray-500">R$ {(item.pPrice * 1.2).toFixed(2).replace('.', ',')}</span>
                        <span className="ml-2 px-1.5 py-0.5 text-xs font-semibold bg-green-100 text-green-800 rounded-full">20% OFF</span>
                      </div>
                      <div className="text-sm text-gray-600 mt-1">
                        ou 3x de <span className="font-medium">R$ {(item.pPrice / 3).toFixed(2).replace('.', ',')}</span> sem juros
                      </div>
                    </>
                  ) : (
                    <>
                      <span className="text-lg font-bold text-gray-900">R$ {item.pPrice.toFixed(2).replace('.', ',')}</span>
                      <div className="text-sm text-gray-600 mt-1">
                        ou 3x de <span className="font-medium">R$ {(item.pPrice / 3).toFixed(2).replace('.', ',')}</span> sem juros
                      </div>
                    </>
                  )}
                </div>

                {/* Shipping */}
                <div className="mt-2 flex items-center">
                  <FontAwesomeIcon icon={faTruck} className="text-blue-500 mr-1" />
                  <span className="text-xs text-gray-600">Frete Grátis</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-2 md:col-span-3 lg:col-span-4 flex items-center justify-center py-24 text-2xl text-gray-600">
            Produto não encontrado
          </div>
        )}
      </Slider>
    </Fragment>
  );
};

export default SingleProduct;